import type { UseCase } from '@/core/shared'
import type { UserRepository } from '@/core/user'

export const activatePayPerMonthContract: UseCase<UserRepository, 'activatePayPerMonthContract'> = repository => {
  return async (activateContract) => {
    await repository.activatePayPerMonthContract(activateContract)
  }
}
